/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSfContactRelationFields200Response } from '../models';
// @ts-ignore
import { GetSfCustomObjectProductMapping200Response } from '../models';
// @ts-ignore
import { GetSfCustomObjects200Response } from '../models';
// @ts-ignore
import { UpsertSfCustomObjectProductMappingRequest } from '../models';
/**
 * SfCustomObjectProductMappingsApi - axios parameter creator
 * @export
 */
export const SfCustomObjectProductMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商材連携のマッピング情報を削除
         * @summary 商材連携マッピング削除
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSfCustomObjectProductMapping: async (customObjectName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customObjectName' is not null or undefined
            assertParamExists('deleteSfCustomObjectProductMapping', 'customObjectName', customObjectName)
            const localVarPath = `/api/user/salesforce/sf_custom_object_product_mappings/destroy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customObjectName !== undefined) {
                localVarQueryParameter['custom_object_name'] = customObjectName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カスタムオブジェクトの取引責任者参照フィールド一覧を取得
         * @summary 取引責任者関連項目一覧取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfContactRelationFields: async (customObjectName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customObjectName' is not null or undefined
            assertParamExists('getSfContactRelationFields', 'customObjectName', customObjectName)
            const localVarPath = `/api/user/salesforce/sf_custom_object_product_mappings/contact_relation_fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customObjectName !== undefined) {
                localVarQueryParameter['custom_object_name'] = customObjectName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材連携のマッピング情報を取得
         * @summary 商材連携マッピング情報取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCustomObjectProductMapping: async (customObjectName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customObjectName' is not null or undefined
            assertParamExists('getSfCustomObjectProductMapping', 'customObjectName', customObjectName)
            const localVarPath = `/api/user/salesforce/sf_custom_object_product_mappings/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customObjectName !== undefined) {
                localVarQueryParameter['custom_object_name'] = customObjectName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Contactに紐づくカスタムオブジェクト一覧を取得
         * @summary Salesforceカスタムオブジェクト一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCustomObjects: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_custom_object_product_mappings/custom_objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材連携のマッピング情報を保存
         * @summary 商材連携マッピング保存
         * @param {UpsertSfCustomObjectProductMappingRequest} [upsertSfCustomObjectProductMappingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSfCustomObjectProductMapping: async (upsertSfCustomObjectProductMappingRequest?: UpsertSfCustomObjectProductMappingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_custom_object_product_mappings/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSfCustomObjectProductMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SfCustomObjectProductMappingsApi - functional programming interface
 * @export
 */
export const SfCustomObjectProductMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SfCustomObjectProductMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 商材連携のマッピング情報を削除
         * @summary 商材連携マッピング削除
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSfCustomObjectProductMapping(customObjectName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSfCustomObjectProductMapping(customObjectName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カスタムオブジェクトの取引責任者参照フィールド一覧を取得
         * @summary 取引責任者関連項目一覧取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfContactRelationFields(customObjectName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfContactRelationFields200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfContactRelationFields(customObjectName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材連携のマッピング情報を取得
         * @summary 商材連携マッピング情報取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfCustomObjectProductMapping(customObjectName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfCustomObjectProductMapping200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfCustomObjectProductMapping(customObjectName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Contactに紐づくカスタムオブジェクト一覧を取得
         * @summary Salesforceカスタムオブジェクト一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfCustomObjects(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfCustomObjects200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfCustomObjects(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材連携のマッピング情報を保存
         * @summary 商材連携マッピング保存
         * @param {UpsertSfCustomObjectProductMappingRequest} [upsertSfCustomObjectProductMappingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSfCustomObjectProductMapping(upsertSfCustomObjectProductMappingRequest?: UpsertSfCustomObjectProductMappingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSfCustomObjectProductMapping(upsertSfCustomObjectProductMappingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SfCustomObjectProductMappingsApi - factory interface
 * @export
 */
export const SfCustomObjectProductMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SfCustomObjectProductMappingsApiFp(configuration)
    return {
        /**
         * 商材連携のマッピング情報を削除
         * @summary 商材連携マッピング削除
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSfCustomObjectProductMapping(customObjectName: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSfCustomObjectProductMapping(customObjectName, options).then((request) => request(axios, basePath));
        },
        /**
         * カスタムオブジェクトの取引責任者参照フィールド一覧を取得
         * @summary 取引責任者関連項目一覧取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfContactRelationFields(customObjectName: string, options?: any): AxiosPromise<GetSfContactRelationFields200Response> {
            return localVarFp.getSfContactRelationFields(customObjectName, options).then((request) => request(axios, basePath));
        },
        /**
         * 商材連携のマッピング情報を取得
         * @summary 商材連携マッピング情報取得
         * @param {string} customObjectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCustomObjectProductMapping(customObjectName: string, options?: any): AxiosPromise<GetSfCustomObjectProductMapping200Response> {
            return localVarFp.getSfCustomObjectProductMapping(customObjectName, options).then((request) => request(axios, basePath));
        },
        /**
         * Contactに紐づくカスタムオブジェクト一覧を取得
         * @summary Salesforceカスタムオブジェクト一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCustomObjects(options?: any): AxiosPromise<GetSfCustomObjects200Response> {
            return localVarFp.getSfCustomObjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 商材連携のマッピング情報を保存
         * @summary 商材連携マッピング保存
         * @param {UpsertSfCustomObjectProductMappingRequest} [upsertSfCustomObjectProductMappingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSfCustomObjectProductMapping(upsertSfCustomObjectProductMappingRequest?: UpsertSfCustomObjectProductMappingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.upsertSfCustomObjectProductMapping(upsertSfCustomObjectProductMappingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SfCustomObjectProductMappingsApi - interface
 * @export
 * @interface SfCustomObjectProductMappingsApi
 */
export interface SfCustomObjectProductMappingsApiInterface {
    /**
     * 商材連携のマッピング情報を削除
     * @summary 商材連携マッピング削除
     * @param {string} customObjectName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApiInterface
     */
    deleteSfCustomObjectProductMapping(customObjectName: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * カスタムオブジェクトの取引責任者参照フィールド一覧を取得
     * @summary 取引責任者関連項目一覧取得
     * @param {string} customObjectName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApiInterface
     */
    getSfContactRelationFields(customObjectName: string, options?: AxiosRequestConfig): AxiosPromise<GetSfContactRelationFields200Response>;

    /**
     * 商材連携のマッピング情報を取得
     * @summary 商材連携マッピング情報取得
     * @param {string} customObjectName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApiInterface
     */
    getSfCustomObjectProductMapping(customObjectName: string, options?: AxiosRequestConfig): AxiosPromise<GetSfCustomObjectProductMapping200Response>;

    /**
     * Contactに紐づくカスタムオブジェクト一覧を取得
     * @summary Salesforceカスタムオブジェクト一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApiInterface
     */
    getSfCustomObjects(options?: AxiosRequestConfig): AxiosPromise<GetSfCustomObjects200Response>;

    /**
     * 商材連携のマッピング情報を保存
     * @summary 商材連携マッピング保存
     * @param {UpsertSfCustomObjectProductMappingRequest} [upsertSfCustomObjectProductMappingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApiInterface
     */
    upsertSfCustomObjectProductMapping(upsertSfCustomObjectProductMappingRequest?: UpsertSfCustomObjectProductMappingRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteSfCustomObjectProductMapping operation in SfCustomObjectProductMappingsApi.
 * @export
 * @interface SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest
 */
export interface SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMapping
     */
    readonly customObjectName: string
}

/**
 * Request parameters for getSfContactRelationFields operation in SfCustomObjectProductMappingsApi.
 * @export
 * @interface SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest
 */
export interface SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof SfCustomObjectProductMappingsApiGetSfContactRelationFields
     */
    readonly customObjectName: string
}

/**
 * Request parameters for getSfCustomObjectProductMapping operation in SfCustomObjectProductMappingsApi.
 * @export
 * @interface SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest
 */
export interface SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof SfCustomObjectProductMappingsApiGetSfCustomObjectProductMapping
     */
    readonly customObjectName: string
}

/**
 * Request parameters for upsertSfCustomObjectProductMapping operation in SfCustomObjectProductMappingsApi.
 * @export
 * @interface SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest
 */
export interface SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest {
    /**
     * 
     * @type {UpsertSfCustomObjectProductMappingRequest}
     * @memberof SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMapping
     */
    readonly upsertSfCustomObjectProductMappingRequest?: UpsertSfCustomObjectProductMappingRequest
}

/**
 * SfCustomObjectProductMappingsApi - object-oriented interface
 * @export
 * @class SfCustomObjectProductMappingsApi
 * @extends {BaseAPI}
 */
export class SfCustomObjectProductMappingsApi extends BaseAPI implements SfCustomObjectProductMappingsApiInterface {
    /**
     * 商材連携のマッピング情報を削除
     * @summary 商材連携マッピング削除
     * @param {SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApi
     */
    public deleteSfCustomObjectProductMapping(requestParameters: SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest, options?: AxiosRequestConfig) {
        return SfCustomObjectProductMappingsApiFp(this.configuration).deleteSfCustomObjectProductMapping(requestParameters.customObjectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カスタムオブジェクトの取引責任者参照フィールド一覧を取得
     * @summary 取引責任者関連項目一覧取得
     * @param {SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApi
     */
    public getSfContactRelationFields(requestParameters: SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest, options?: AxiosRequestConfig) {
        return SfCustomObjectProductMappingsApiFp(this.configuration).getSfContactRelationFields(requestParameters.customObjectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材連携のマッピング情報を取得
     * @summary 商材連携マッピング情報取得
     * @param {SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApi
     */
    public getSfCustomObjectProductMapping(requestParameters: SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest, options?: AxiosRequestConfig) {
        return SfCustomObjectProductMappingsApiFp(this.configuration).getSfCustomObjectProductMapping(requestParameters.customObjectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Contactに紐づくカスタムオブジェクト一覧を取得
     * @summary Salesforceカスタムオブジェクト一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApi
     */
    public getSfCustomObjects(options?: AxiosRequestConfig) {
        return SfCustomObjectProductMappingsApiFp(this.configuration).getSfCustomObjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材連携のマッピング情報を保存
     * @summary 商材連携マッピング保存
     * @param {SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCustomObjectProductMappingsApi
     */
    public upsertSfCustomObjectProductMapping(requestParameters: SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest = {}, options?: AxiosRequestConfig) {
        return SfCustomObjectProductMappingsApiFp(this.configuration).upsertSfCustomObjectProductMapping(requestParameters.upsertSfCustomObjectProductMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
